import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import injectSheet from 'react-jss';
import { TitleService } from '../../services';
import { SiteNameTypeAheadQuery } from '../../graphql/queries';
import EditRelationship from './buyer-relationship';
import { Breadcrumbs } from '../../store';
import { useQuery } from '@apollo/client';

const styles = {
  adminContainerWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginBottom: '1em',
  },
  editSiteWrapper: {
    width: '75%',
  },
};

const EditSite = () => {
  const values = queryString.parse(location.search);
  const { data } = useQuery(SiteNameTypeAheadQuery, {
    variables: {
      typeAhead: {
        search: values.siteName || '',
        itemLimit: 1,
      },
    },
  });

  const result =
    values.siteName && data?.siteNameTypeAheadQuery?.length > 0 ? data.siteNameTypeAheadQuery[0].result : undefined;

  useEffect(() => {
    TitleService.setTitles('BSR Editor');
    Breadcrumbs.set([
      {
        url: '/edit-bsr',
        title: 'BSR Editor',
      },
    ]);
  }, []);

  return (
    <div id="edit-sites">
      <div>
        <EditRelationship />
      </div>
    </div>
  );
};

EditSite.propTypes = {
  classes: PropTypes.object,
};

export default injectSheet(styles)(EditSite);
